<div class="admin-tlr-container">
  <span class="air-heading">	
TLR Administrator IPEG</span>

  <p-table [value]="users" class="mt-10" styleClass="p-datatable-gridlines" id="StyleTable" scrollHeight="500px" [tableStyle]="{'min-width': '50rem'}">
    <ng-template pTemplate="header">
      <tr>
        <th class="align-center">Site ID</th>
        <th class="align-center">CAI</th>
        <th class="align-center">Security Level</th>
        <th class="align-center">Security Description</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
      <tr>
        <td class="align-center">{{ user.siteId }}</td>
        <td class="align-center">{{ user.cai }}</td>
        <td class="align-center">{{ user.securityLevel }}</td>
        <td class="align-center">{{ user.securityDescription }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
